var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.address
        ? [
            _vm.isAddressFieldEnabled("name1")
              ? [
                  _vm.address &&
                  _vm.address.name1 &&
                  _vm.address.name1.length > 0
                    ? _c("div", { staticClass: "font-bold" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.address.name1) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.isAddressFieldEnabled("contactPerson")
              ? [
                  _c("div", [
                    _vm._v(_vm._s(_vm._f("optionType")(_vm.address, 12))),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.isAddressFieldEnabled("title") ||
            _vm.isAddressFieldEnabled("name2") ||
            _vm.isAddressFieldEnabled("name3") ||
            _vm.isAddressFieldEnabled("gender")
              ? [
                  !_vm.address.name1 || _vm.address.name1.length == 0
                    ? _c(
                        "div",
                        { staticClass: "font-bold" },
                        [
                          _vm.isAddressFieldEnabled("title")
                            ? [
                                _vm._v(
                                  _vm._s(_vm._f("optionType")(_vm.address, 11))
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isAddressFieldEnabled("name2")
                            ? [_vm._v(_vm._s(_vm.address.name2))]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isAddressFieldEnabled("name3")
                            ? [_vm._v(_vm._s(_vm.address.name3))]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.isAddressFieldEnabled("name4")
              ? _c("div", [_vm._v(_vm._s(_vm.address.name4))])
              : _vm._e(),
            _vm._v(" "),
            _vm.isAddressFieldEnabled("address1") ||
            _vm.isAddressFieldEnabled("address2")
              ? _c(
                  "div",
                  [
                    _vm.isAddressFieldEnabled("address1")
                      ? [_vm._v(_vm._s(_vm.address.address1))]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAddressFieldEnabled("address2")
                      ? [_vm._v(_vm._s(_vm.address.address2))]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isAddressFieldEnabled("address3")
              ? _c(
                  "div",
                  [
                    _vm.address.address1 === "PACKSTATION" ||
                    _vm.address.address1 === "POSTFILIALE"
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.addressPostNummer"
                                )
                              ) +
                              "\n                    " +
                              _vm._s(_vm._f("optionType")(_vm.address, 6)) +
                              "\n                "
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.address.address3) +
                        "\n            "
                    ),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isAddressFieldEnabled("address4")
              ? _c("div", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.address.address4) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isAddressFieldEnabled("postalCode") ||
            _vm.isAddressFieldEnabled("town")
              ? _c(
                  "div",
                  [
                    _vm.isAddressFieldEnabled("postalCode")
                      ? [_vm._v(_vm._s(_vm.address.postalCode))]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAddressFieldEnabled("town")
                      ? [_vm._v(_vm._s(_vm.address.town))]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isAddressFieldEnabled("country")
              ? _c("div", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.getCountryName(_vm.address.countryId)) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }